"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudiencesApi = void 0;
var runtime = require("../runtime");
var index_1 = require("../models/index");
/**
 *
 */
var AudiencesApi = /** @class */ (function (_super) {
    __extends(AudiencesApi, _super);
    function AudiencesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns a list of audiences accessible to the ad account.
     * List Audiences accessible to an Ad Account
     */
    AudiencesApi.prototype.batchGetAudiencesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling batchGetAudiences.');
                        }
                        queryParameters = {};
                        if (requestParameters.audienceIds) {
                            queryParameters['audience_ids'] = requestParameters.audienceIds.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.audienceTypes) {
                            queryParameters['audience_types'] = requestParameters.audienceTypes.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.q !== undefined) {
                            queryParameters['q'] = requestParameters.q;
                        }
                        if (requestParameters.limit !== undefined) {
                            queryParameters['limit'] = requestParameters.limit;
                        }
                        if (requestParameters.offset !== undefined) {
                            queryParameters['offset'] = requestParameters.offset;
                        }
                        if (requestParameters.sortDirection !== undefined) {
                            queryParameters['sort_direction'] = requestParameters.sortDirection;
                        }
                        if (requestParameters.sortField !== undefined) {
                            queryParameters['sort_field'] = requestParameters.sortField;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/ad_accounts/{ad_account_id}/audiences".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.AudiencesListResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns a list of audiences accessible to the ad account.
     * List Audiences accessible to an Ad Account
     */
    AudiencesApi.prototype.batchGetAudiences = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.batchGetAudiencesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates a new audience.
     * Create an Audience
     */
    AudiencesApi.prototype.createAudienceRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling createAudience.');
                        }
                        if (requestParameters.createAudienceRequest === null || requestParameters.createAudienceRequest === undefined) {
                            throw new runtime.RequiredError('createAudienceRequest', 'Required parameter requestParameters.createAudienceRequest was null or undefined when calling createAudience.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/ad_accounts/{ad_account_id}/audiences".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.CreateAudienceRequestToJSON)(requestParameters.createAudienceRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.AudienceResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Creates a new audience.
     * Create an Audience
     */
    AudiencesApi.prototype.createAudience = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createAudienceRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates a new internal custom audience.
     * Create an internal custom audience
     */
    AudiencesApi.prototype.createInternalCustomAudienceRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling createInternalCustomAudience.');
                        }
                        if (requestParameters.createInternalCustomAudienceRequest === null || requestParameters.createInternalCustomAudienceRequest === undefined) {
                            throw new runtime.RequiredError('createInternalCustomAudienceRequest', 'Required parameter requestParameters.createInternalCustomAudienceRequest was null or undefined when calling createInternalCustomAudience.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/internal/ad_accounts/{ad_account_id}/custom_audiences".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.CreateInternalCustomAudienceRequestToJSON)(requestParameters.createInternalCustomAudienceRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.AudienceResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Creates a new internal custom audience.
     * Create an internal custom audience
     */
    AudiencesApi.prototype.createInternalCustomAudience = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createInternalCustomAudienceRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get Signed GCS upload URL.
     * Get Signed GCS upload URL to upload a user list file
     */
    AudiencesApi.prototype.createUploadUrlRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling createUploadUrl.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/ad_accounts/{ad_account_id}/audiences/upload_url".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.CreateUploadUrlResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get Signed GCS upload URL.
     * Get Signed GCS upload URL to upload a user list file
     */
    AudiencesApi.prototype.createUploadUrl = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createUploadUrlRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Deletes an audience.
     * Delete an Audience
     */
    AudiencesApi.prototype.deleteAudienceRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling deleteAudience.');
                        }
                        if (requestParameters.audienceId === null || requestParameters.audienceId === undefined) {
                            throw new runtime.RequiredError('audienceId', 'Required parameter requestParameters.audienceId was null or undefined when calling deleteAudience.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/ad_accounts/{ad_account_id}/audiences/{audience_id}".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))).replace("{".concat("audience_id", "}"), encodeURIComponent(String(requestParameters.audienceId))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.DeleteAudienceResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Deletes an audience.
     * Delete an Audience
     */
    AudiencesApi.prototype.deleteAudience = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteAudienceRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Deletes an audience for test cleanup.
     * Delete an Audience for test cleanup
     */
    AudiencesApi.prototype.deleteAudienceForCleanupRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling deleteAudienceForCleanup.');
                        }
                        if (requestParameters.audienceId === null || requestParameters.audienceId === undefined) {
                            throw new runtime.RequiredError('audienceId', 'Required parameter requestParameters.audienceId was null or undefined when calling deleteAudienceForCleanup.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/internal/ad_accounts/{ad_account_id}/audiences/{audience_id}".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))).replace("{".concat("audience_id", "}"), encodeURIComponent(String(requestParameters.audienceId))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Deletes an audience for test cleanup.
     * Delete an Audience for test cleanup
     */
    AudiencesApi.prototype.deleteAudienceForCleanup = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteAudienceForCleanupRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Edits an audience.
     * Edit an Audience
     */
    AudiencesApi.prototype.editAudienceRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.audienceId === null || requestParameters.audienceId === undefined) {
                            throw new runtime.RequiredError('audienceId', 'Required parameter requestParameters.audienceId was null or undefined when calling editAudience.');
                        }
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling editAudience.');
                        }
                        if (requestParameters.editAudienceRequest === null || requestParameters.editAudienceRequest === undefined) {
                            throw new runtime.RequiredError('editAudienceRequest', 'Required parameter requestParameters.editAudienceRequest was null or undefined when calling editAudience.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/ad_accounts/{ad_account_id}/audiences/{audience_id}".replace("{".concat("audience_id", "}"), encodeURIComponent(String(requestParameters.audienceId))).replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))),
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.EditAudienceRequestToJSON)(requestParameters.editAudienceRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.AudienceResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Edits an audience.
     * Edit an Audience
     */
    AudiencesApi.prototype.editAudience = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.editAudienceRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns an audience.
     * Get an Audience
     */
    AudiencesApi.prototype.getAudienceRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.audienceId === null || requestParameters.audienceId === undefined) {
                            throw new runtime.RequiredError('audienceId', 'Required parameter requestParameters.audienceId was null or undefined when calling getAudience.');
                        }
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling getAudience.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/ad_accounts/{ad_account_id}/audiences/{audience_id}".replace("{".concat("audience_id", "}"), encodeURIComponent(String(requestParameters.audienceId))).replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.AudienceResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns an audience.
     * Get an Audience
     */
    AudiencesApi.prototype.getAudience = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAudienceRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get Signed GCS upload URL to replace an existing audience
     * Get Signed GCS upload URL to upload a user list file for an existing audience
     */
    AudiencesApi.prototype.replaceUploadUrlRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.adAccountId === null || requestParameters.adAccountId === undefined) {
                            throw new runtime.RequiredError('adAccountId', 'Required parameter requestParameters.adAccountId was null or undefined when calling replaceUploadUrl.');
                        }
                        if (requestParameters.audienceId === null || requestParameters.audienceId === undefined) {
                            throw new runtime.RequiredError('audienceId', 'Required parameter requestParameters.audienceId was null or undefined when calling replaceUploadUrl.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/ad_accounts/{ad_account_id}/audiences/upload_url/{audience_id}".replace("{".concat("ad_account_id", "}"), encodeURIComponent(String(requestParameters.adAccountId))).replace("{".concat("audience_id", "}"), encodeURIComponent(String(requestParameters.audienceId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.CreateUploadUrlResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get Signed GCS upload URL to replace an existing audience
     * Get Signed GCS upload URL to upload a user list file for an existing audience
     */
    AudiencesApi.prototype.replaceUploadUrl = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.replaceUploadUrlRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return AudiencesApi;
}(runtime.BaseAPI));
exports.AudiencesApi = AudiencesApi;
